// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Public Profile Styles */
.profile-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 400px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
}

.profile-header-content {
  padding: 2rem 0;
}

.profile-pic-wrapper {
  position: relative;
}

.profile-pic-large {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 5px solid white;
  object-fit: cover;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Cards and Content */
.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-title {
  color: #333;
  font-weight: 600;
}

/* Info List */
.info-list i {
  color: var(--accent-color, #007bff);
  width: 20px;
}

/* Social Links */
.social-links .btn {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.social-links .btn:hover {
  transform: scale(1.1);
}

/* Interests Badges */
.badge.rounded-pill {
  padding: 0.5rem 1rem;
  font-weight: normal;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.badge.rounded-pill:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

/* Stats Section */
.card .btn-link:hover h3 {
  color: var(--accent-color, #007bff);
  transition: color 0.2s;
}

/* Follow/Following Lists */
.list-group-item {
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 1rem;
  transition: background-color 0.2s;
}

.list-group-item:last-child {
  border-bottom: none;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

/* Modal Customizations */
.modal-dialog-scrollable .modal-body {
  max-height: 70vh;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

/* Form Elements */
.form-control, .form-select {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus, .form-select:focus {
  border-color: var(--accent-color, #007bff);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);
}

.form-control-color {
  height: 38px;
  border-radius: 8px;
}

/* Buttons */
.btn {
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background-color: var(--accent-color, #007bff);
  border-color: var(--accent-color, #007bff);
}

.btn-primary:hover {
  background-color: var(--accent-color, #0056b3);
  border-color: var(--accent-color, #0056b3);
  filter: brightness(0.9);
}

.btn-outline-primary {
  color: var(--accent-color, #007bff);
  border-color: var(--accent-color, #007bff);
}

.btn-outline-primary:hover {
  background-color: var(--accent-color, #007bff);
  border-color: var(--accent-color, #007bff);
}

/* Loading Spinner */
.spinner-border {
  color: var(--accent-color, #007bff);
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-section {
    min-height: 300px;
  }
  
  .profile-pic-large {
    width: 100px;
    height: 100px;
  }
  
  .display-4 {
    font-size: 2rem;
  }
  
  .profile-header-content {
    text-align: center;
  }
  
  .profile-header-content .d-flex {
    flex-direction: column;
    align-items: center;
  }
  
  .profile-header-content .ms-4 {
    margin-left: 0 !important;
    margin-top: 1rem;
  }
}

/* Theme-specific overrides */
.profile-page[data-theme="dark"] {
  background-color: #1a1a1a;
  color: #fff;
}

.profile-page[data-theme="dark"] .card {
  background-color: #2a2a2a;
  color: #fff;
}

.profile-page[data-theme="dark"] .card-title,
.profile-page[data-theme="dark"] .text-dark {
  color: #fff !important;
}

.profile-page[data-theme="dark"] .list-group-item {
  background-color: #2a2a2a;
  color: #fff;
  border-color: #444;
}

.profile-page[data-theme="dark"] .list-group-item:hover {
  background-color: #333;
}

/* Animation Effects */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.5s ease-out;
}

.hero-section {
  animation: fadeIn 0.8s ease-out;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: var(--accent-color, #888);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color, #555);
}

/* Alert Customization */
.alert {
  border-radius: 8px;
  border: none;
  animation: fadeIn 0.3s ease-out;
}

/* Badge customization for interests */
.badge.bg-primary {
  background-color: var(--accent-color, #007bff) !important;
}

/* Edit modal interest badges */
.badge .btn-close {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.badge:hover .btn-close {
  opacity: 1;
}

/* Profile theme gradients */
.hero-section.theme-default {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.hero-section.theme-dark {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}

.hero-section.theme-ocean {
  background: linear-gradient(135deg, #48cae4 0%, #0096c7 100%);
}

.hero-section.theme-sunset {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.hero-section.theme-forest {
  background: linear-gradient(135deg, #2d6a4f 0%, #74c69d 100%);
}

.hero-section.theme-vintage {
  background: linear-gradient(135deg, #4a4e69 0%, #9a8c98 100%);
}`, "",{"version":3,"sources":["webpack://./src/PublicProfile.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,yDAAyD;AAC3D;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D","sourcesContent":["/* Public Profile Styles */\n.profile-page {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  min-height: 400px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: flex-end;\n}\n\n.profile-header-content {\n  padding: 2rem 0;\n}\n\n.profile-pic-wrapper {\n  position: relative;\n}\n\n.profile-pic-large {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  border: 5px solid white;\n  object-fit: cover;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Cards and Content */\n.card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.card-title {\n  color: #333;\n  font-weight: 600;\n}\n\n/* Info List */\n.info-list i {\n  color: var(--accent-color, #007bff);\n  width: 20px;\n}\n\n/* Social Links */\n.social-links .btn {\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.social-links .btn:hover {\n  transform: scale(1.1);\n}\n\n/* Interests Badges */\n.badge.rounded-pill {\n  padding: 0.5rem 1rem;\n  font-weight: normal;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.badge.rounded-pill:hover {\n  transform: scale(1.05);\n  filter: brightness(1.1);\n}\n\n/* Stats Section */\n.card .btn-link:hover h3 {\n  color: var(--accent-color, #007bff);\n  transition: color 0.2s;\n}\n\n/* Follow/Following Lists */\n.list-group-item {\n  border: none;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 1rem;\n  transition: background-color 0.2s;\n}\n\n.list-group-item:last-child {\n  border-bottom: none;\n}\n\n.list-group-item:hover {\n  background-color: #f8f9fa;\n}\n\n/* Modal Customizations */\n.modal-dialog-scrollable .modal-body {\n  max-height: 70vh;\n}\n\n.modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-footer {\n  background-color: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n}\n\n/* Form Elements */\n.form-control, .form-select {\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-control:focus, .form-select:focus {\n  border-color: var(--accent-color, #007bff);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);\n}\n\n.form-control-color {\n  height: 38px;\n  border-radius: 8px;\n}\n\n/* Buttons */\n.btn {\n  border-radius: 8px;\n  padding: 0.5rem 1rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary {\n  background-color: var(--accent-color, #007bff);\n  border-color: var(--accent-color, #007bff);\n}\n\n.btn-primary:hover {\n  background-color: var(--accent-color, #0056b3);\n  border-color: var(--accent-color, #0056b3);\n  filter: brightness(0.9);\n}\n\n.btn-outline-primary {\n  color: var(--accent-color, #007bff);\n  border-color: var(--accent-color, #007bff);\n}\n\n.btn-outline-primary:hover {\n  background-color: var(--accent-color, #007bff);\n  border-color: var(--accent-color, #007bff);\n}\n\n/* Loading Spinner */\n.spinner-border {\n  color: var(--accent-color, #007bff);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-section {\n    min-height: 300px;\n  }\n  \n  .profile-pic-large {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .display-4 {\n    font-size: 2rem;\n  }\n  \n  .profile-header-content {\n    text-align: center;\n  }\n  \n  .profile-header-content .d-flex {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .profile-header-content .ms-4 {\n    margin-left: 0 !important;\n    margin-top: 1rem;\n  }\n}\n\n/* Theme-specific overrides */\n.profile-page[data-theme=\"dark\"] {\n  background-color: #1a1a1a;\n  color: #fff;\n}\n\n.profile-page[data-theme=\"dark\"] .card {\n  background-color: #2a2a2a;\n  color: #fff;\n}\n\n.profile-page[data-theme=\"dark\"] .card-title,\n.profile-page[data-theme=\"dark\"] .text-dark {\n  color: #fff !important;\n}\n\n.profile-page[data-theme=\"dark\"] .list-group-item {\n  background-color: #2a2a2a;\n  color: #fff;\n  border-color: #444;\n}\n\n.profile-page[data-theme=\"dark\"] .list-group-item:hover {\n  background-color: #333;\n}\n\n/* Animation Effects */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card {\n  animation: fadeIn 0.5s ease-out;\n}\n\n.hero-section {\n  animation: fadeIn 0.8s ease-out;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--accent-color, #888);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--accent-color, #555);\n}\n\n/* Alert Customization */\n.alert {\n  border-radius: 8px;\n  border: none;\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Badge customization for interests */\n.badge.bg-primary {\n  background-color: var(--accent-color, #007bff) !important;\n}\n\n/* Edit modal interest badges */\n.badge .btn-close {\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.badge:hover .btn-close {\n  opacity: 1;\n}\n\n/* Profile theme gradients */\n.hero-section.theme-default {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.hero-section.theme-dark {\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n}\n\n.hero-section.theme-ocean {\n  background: linear-gradient(135deg, #48cae4 0%, #0096c7 100%);\n}\n\n.hero-section.theme-sunset {\n  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\n}\n\n.hero-section.theme-forest {\n  background: linear-gradient(135deg, #2d6a4f 0%, #74c69d 100%);\n}\n\n.hero-section.theme-vintage {\n  background: linear-gradient(135deg, #4a4e69 0%, #9a8c98 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
